module.exports = __webpack_public_path__ + "static/media/reta-logo.32aee262.svg";